import { RootState } from "types";
import { QuoteStatus, QuotesState } from "../types";
import { initialState } from "./slice";

export const selectQuotesState = (state: RootState): QuotesState =>
  state.quotesState || initialState;

export const selectQuotesSearch = (state: RootState) =>
  selectQuotesState(state).search;

export const selectQuotesStatusFilter = (state: RootState) =>
  selectQuotesState(state).statusFilter;

export const selectQuotesLoading = (state: RootState) =>
  selectQuotesState(state).loading;

export const selectQuoteDetailsLoading = (state: RootState) =>
  selectQuotesState(state).detailLoading;

export const selectSelectedQuote = (state: RootState) =>
  selectQuotesState(state).selectedQuote;

export const selectQuoteById = (state: RootState, quoteId: string) => {
  const { list, selectedQuote } = selectQuotesState(state);

  if (selectedQuote?.id === quoteId) {
    return selectedQuote;
  }

  return list.find((quote) => quote.id === quoteId) || null;
};

export const selectQuotesList = (state: RootState) => {
  const { list, search, statusFilter } = selectQuotesState(state);
  const searchValue = search.trim().toLowerCase();

  return list.filter((quote) => {
    const matchesSearch =
      !searchValue ||
      quote.quoteNumber.toLowerCase().includes(searchValue) ||
      quote.customerNameKey.toLowerCase().includes(searchValue) ||
      quote.projectTypeKey.toLowerCase().includes(searchValue);

    const matchesStatus =
      statusFilter === "ALL" || quote.status === statusFilter;

    return matchesSearch && matchesStatus;
  });
};

export const selectQuoteStatusLabelKey = (status: QuoteStatus) => {
  switch (status) {
    case QuoteStatus.DRAFT:
      return "QUOTES.STATUS.DRAFT";

    case QuoteStatus.SENT:
      return "QUOTES.STATUS.SENT";

    case QuoteStatus.ACCEPTED:
      return "QUOTES.STATUS.ACCEPTED";

    default:
      return "";
  }
};